import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagPermitirVentaSinStock = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagPermitirVentaSinStock'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagPermitirVentaSinStock' label='Permitir Venta Sin Stock' />
      )}
    </Field>
  )
}

export default React.memo(FlagPermitirVentaSinStock)
